import { TextField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, getFormSyncErrors, isDirty, reset } from "redux-form"

const required = value => (value ? undefined : "Required")

const DetailsTab = ({
  isDirty,
  resetForm,
  tabIsActive,
  handleSave,
  formSyncErrors,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (
      !tabIsActive &&
      isDirty &&
      (!formSyncErrors || Object?.keys(formSyncErrors)?.length === 0)
    ) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>SET PRODUCT GROUP DETAILS</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xl={6}>
              <Field
                name="name"
                label="Product Group Name"
                component={TextField}
                validate={[required]}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xl={6}>
              <Field
                name="inventory"
                label="Inventory"
                component={TextField}
                // validate={[required]}
                type="number"
                min="0"
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDirty: isDirty(FORM_NAMES.PRODUCT_CATEGORIES)(state, ...["details"]),
  formSyncErrors: getFormSyncErrors(FORM_NAMES.PRODUCT_CATEGORIES)(state),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.PRODUCT_CATEGORIES)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTab)
